module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "on-clickaway",
      rawName: "v-on-clickaway",
      value: (_vm.onClickaway),
      expression: "onClickaway"
    }],
    staticClass: "autocomplete-template-wrapper"
  }, [_c('div', {
    staticClass: "category-templates-dropdown clickable",
    on: {
      "click": _vm.toggleCategories
    }
  }, [_vm._v(_vm._s(_vm.label_category))]), (_vm.show_categories) ? _c('div', {
    directives: [{
      name: "on-clickaway",
      rawName: "v-on-clickaway",
      value: (_vm.hideCategories),
      expression: "hideCategories"
    }],
    staticClass: "category-template-items"
  }, [_vm._l((_vm.categories), function(category) {
    return _c('div', {
      staticClass: "category-item",
      on: {
        "click": function($event) {
          return _vm.selectCategory(category)
        }
      }
    }, [_vm._v(_vm._s(category.name))])
  }), (_vm.category_selected) ? _c('div', {
    staticClass: "category-item",
    on: {
      "click": function($event) {
        return _vm.selectCategory(null)
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('template.label.allCategories')))]) : _vm._e()], 2) : _vm._e(), _c('v-autocomplete', {
    attrs: {
      "id": _vm.id,
      "min-len": 0,
      "items": _vm.templates,
      "get-label": _vm.getLabel,
      "component-item": _vm.item_template,
      "input-attrs": _vm.attrs,
      "keep-open": _vm.keep_items_open,
      "auto-select-one-item": false
    },
    on: {
      "update-items": _vm.searchTemplates,
      "item-selected": _vm.addTemplate
    },
    model: {
      value: (_vm.template),
      callback: function($$v) {
        _vm.template = $$v
      },
      expression: "template"
    }
  }), (_vm.show_not_result_without_modal) ? _c('div', {
    staticClass: "no-result-found"
  }, [_vm._v(_vm._s(_vm.$t('flows.feedback.noResults')))]) : _vm._e(), (_vm.show_not_result_with_modal) ? _c('div', {
    staticClass: "no-result-found",
    on: {
      "click": _vm.openCreateTemplateModal
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.input_text))]), _c('span', {
    staticClass: "create",
    staticStyle: {
      "margin-left": "30px"
    }
  }, [_vm._v(_vm._s(_vm.$t('general.actions.create')))])]) : _vm._e(), (_vm.input_text || _vm.template) ? _c('span', {
    staticClass: "clear-form glyphicon glyphicon-remove",
    on: {
      "click": function($event) {
        return _vm.clearTemplate(true)
      }
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-7995eae0!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/shared/autocomplete/templates.vue
// module id = 1174
// module chunks = 1